import { render, staticRenderFns } from "./partnershipFunds.vue?vue&type=template&id=609484b4&"
import script from "./partnershipFunds.vue?vue&type=script&lang=js&"
export * from "./partnershipFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports